import groupsTemplate from './templates/groups.template.html';

/*******************************************************************************
 * Component: groupsEntityContent
 *
 * Component to manage the Groups route content.
 *******************************************************************************/
export const groupsEntityContentComponent = {
  require: { dialogCtrl: '^^entitiesAdmin' },
  template: groupsTemplate,
  controller: 'GroupsEntityController',
  controllerAs: '$groupsCtrl'
}

/* @ngInject */ export function GroupsEntityController(
  $q,
  Alert,
  AddChangeGroupDialog,
  SERVER,
  BusyScreen,
  EntitiesAdminService,
  GroupsListDialog,
  GroupsSvc,
  uiGridConstants
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Controller Instance Reference. */ var mThis = this;
  /** Add/Change Group Dialog shown. */ var mAddChangeGroupDialogActive = false;
  /** Names List Dialog shown. */ var mGroupsListDialogActive = false;

  /*--------------------------------------------------------*/
  /* Template to add double click functionality to each row */
  /*--------------------------------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.handleGroup(false, row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

  /*--------------------------------------*/
  /* Template for the actions column with */
  /* icons to edit and remove groups.     */
  /*--------------------------------------*/
  var actionsCellTemplate =
    '<div class="ui-grid-cell-contents ng-binding ng-scope"> ' +
    '<span style="cursor:pointer" class="glyphicon glyphicon-edit  csm-grid-space-target" title="Change Group" ng-click="(col.colDef.appScope || grid.appScope).handleGroup(false, row.entity)"></span> &nbsp;' +
    '<span style="cursor:pointer" class="glyphicon glyphicon-trash csm-grid-space-target" title="Remove Group" ng-click="(col.colDef.appScope || grid.appScope).removeGroup(row.entity)"></span>' +
    '</div>';
  /*---------------------*/
  /* Groups grid options */
  /*---------------------*/
  mThis.dgGroups = {
    enableColumnMenus: false,
    enableFiltering: true,
    enableFullRowSelection: true,
    enableRowHeaderSelection: false,
    enableSelectAll: false,
    enableRowSelection: true,
    multiSelect: false,
    saveFilter: true,
    saveSort: true,
    rowTemplate: dblClickTemplate,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    onRegisterApi: function (gridApi) {
      mThis.dgGroups.api = gridApi;
    },
    data: [],
    columnDefs: [
      {
        cellClass: getInactiveCellClass,
        field: 'name',
        minWidth: 150
      },
      {
        cellClass: getInactiveCellClass,
        field: 'notes',
        displayName: 'Description',
        minWidth: 150
      },
      {
        cellClass: getInactiveCellClass,
        field: 'active',
        minWidth: 75,
        width: '9%',
        displayName: 'Active?',
        cellFilter: 'boolToString',
        filter: {
          term: null,
          type: uiGridConstants.filter.SELECT,
          selectOptions: [
            { value: null, label: 'ALL' },
            { value: true, label: 'Y' },
            { value: false, label: 'N' }
          ]
        }
      },
      {
        cellTemplate: actionsCellTemplate,
        enableFiltering: false,
        enableSorting: false,
        field: 'actions',
        width: 70,
        displayName: 'Actions',
        pinnedRight: true,
        appScope: mThis
      }
    ]
  };

  /***************************************************************************
   * getInactiveCellClass */
  /**
   * Returns the CSS class name to be applied to the grid cell on inactive
   * items.
   *
   * @param  grid   ui-grid reference
   * @param  row    ui-grid row
   * @param  col    ui-grid column
   *
   * @return  String   CSS class name inactive-cell-content or empty string.
   ***************************************************************************/
  function getInactiveCellClass(grid, row, col) {
    return !row.entity.active ? 'inactive-cell-content' : '';
  }

  /***************************************************************************
   * handleGroup */
  /**
   * Event handling for adding/modifying groups.
   *
   * @param   addMode  True=Adding a new group, false, modifying an existing
   *                   group.
   * @param   group    Group to modify
   ***************************************************************************/
  mThis.handleGroup = function (addMode, group) {
    /*------------------------------*/
    /* Dialog already active, exit. */
    /*------------------------------*/
    if (mAddChangeGroupDialogActive) return;

    /*-----------------------------------------------------*/
    /* When modifying a group, alert if no group provided. */
    /*-----------------------------------------------------*/
    if (!addMode && !group) {
      Alert.error('Please select a group to modify');
      return;
    }

    /*--------------------------------------------------*/
    /* Properties to be passed to AddChangeGroupDialog. */
    /*--------------------------------------------------*/
    var membersOnly = false;
    var showTitle = true;
    var groupID = !addMode ? group.id : 0;
    var groupType = 0;
    var saveGroup = true;
    var entityList;

    /*------------------------------------------------------------*/
    /* Before displaying the dialog, check if the entities list   */
    /* has been loaded. If the user refreshed the page on this    */
    /* route, the list will not be available. Check if the list   */
    /* is available, if not display BusyScreen and load the list. */
    /*------------------------------------------------------------*/
    $q.when(
      EntitiesAdminService.getNames() == 0
        ? (BusyScreen.setBusy(true),
          EntitiesAdminService.reloadNames().then(function () {
            BusyScreen.setBusy(false);
          }))
        : null
    ).then(function () {
      /*----------------------------*/
      /* Save the list of entities. */
      /*----------------------------*/
      entityList = EntitiesAdminService.getNames();

      /*-----------------*/
      /* Display dialog. */
      /*-----------------*/
      mAddChangeGroupDialogActive = true;
      AddChangeGroupDialog.show(
        membersOnly,
        showTitle,
        groupID,
        groupType,
        saveGroup,
        entityList
      )
        .then(function () {
          /*-----------------------------------*/
          /* Repopulate dialog and alert user. */
          /*-----------------------------------*/
          EntitiesAdminService.reloadGroups().then(function () {
            mThis.dgGroups.data = EntitiesAdminService.getGroups();
            Alert.success(
              'Group successfully ' + (addMode ? 'added.' : 'changed.')
            );
          });
        })
        .finally(function () {
          mAddChangeGroupDialogActive = false;
        });
    });
  };

  /***************************************************************************
   * handlePrint */
  /**
   * Displays the dialog to handle printing.
   ***************************************************************************/
  mThis.handlePrint = function () {
    /*------------------------------*/
    /* Dialog already active, exit. */
    /*------------------------------*/
    if (mGroupsListDialogActive) return;

    /*-------------------------------------*/
    /* Display the dialog to print groups. */
    /*-------------------------------------*/
    mGroupsListDialogActive = true;
    GroupsListDialog.show(mThis.dgGroups.data, false)
      .then(function () {})
      .finally(function () {
        mGroupsListDialogActive = false;
      });
  };

  /*****************************************************************************
   * $onInit */
  /**
   * Initialization callback function. The required dialogCtrl will be available
   * at this point for initialization purposes.
   *****************************************************************************/
  mThis.$onInit = function () {
    /*-----------------------------------------------------*/
    /* To have a reference to the app scope in the grid    */
    /* row template, the grid appScopeProvider will need   */
    /* to be manually setup since we are not using $scope. */
    /*-----------------------------------------------------*/
    this.dgGroups.appScopeProvider = this;

    /*---------------------------*/
    /* Populate the groups grid. */
    /*---------------------------*/
    BusyScreen.setBusy(true);
    EntitiesAdminService.reloadGroups().then(function () {
      BusyScreen.setBusy(false);
      mThis.dgGroups.data = EntitiesAdminService.getGroups();
    });
  };

  /***************************************************************************
   * removeGroup */
  /**
   * Remove the selected group from the list.
   *
   * @param   group   Group to remove
   ***************************************************************************/
  mThis.removeGroup = function (group) {
    /*---------------------------*/
    /* No group to remove, exit. */
    /*---------------------------*/
    if (!group) {
      Alert.error('Select an item to remove.');
      return;
    }

    /*---------------------*/
    /* Confirm the remove. */
    /*---------------------*/
    Alert.confirm(
      'Are you sure wish to remove this group?',
      'Remove Confirm'
    ).then(function () {
      BusyScreen.setBusy(true);

      /*---------------------------------------*/
      /* Remove the group and reload the list. */
      /*---------------------------------------*/
      GroupsSvc.remove(group.id, SERVER.BooksDBConstants.ET_GROUP)
        .then(
          function (resp) {
            EntitiesAdminService.reloadGroups().then(function () {
              mThis.dgGroups.data = EntitiesAdminService.getGroups();
              BusyScreen.setBusy(false);
              Alert.success('Group successfully removed.');
            });
          },
          /*--------------------------------------------------*/
          /* Server responded with an error. Display to user. */
          /*--------------------------------------------------*/
          function (resp) {
            Alert.error(
              resp.parsedResponse.message() || 'Error deleting this group',
              'Failed to remove group.'
            );
          }
        )
        .finally(function () {
          BusyScreen.setBusy(false);
        });
    });
  };
}
